import { render, staticRenderFns } from "./ChargeDetail.vue?vue&type=template&id=b4bc7388&scoped=true&"
import script from "./ChargeDetail.vue?vue&type=script&lang=js&"
export * from "./ChargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChargeDetail.vue?vue&type=style&index=0&id=b4bc7388&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bc7388",
  null
  
)

export default component.exports